module.exports = __webpack_public_path__ + "img/file-search.4f9abc29.svg";